import React from 'react'

export const FirebaseContext = React.createContext({
    currentUser: null,
    setCurrentUser: (firebaseUser) => {}
})

export const FirebaseConsumer = FirebaseContext.Consumer